<template>
  <v-container fluid grid-list-md text-xs-center>
    <v-card>
      <v-card-title>
        <h1>Random Line Picker</h1>
      </v-card-title>
      <v-card-text>
        <v-layout row wrap>
          <v-flex xs12>
            <v-text-field type="number" placeholder="Paste the number of lines" min="1" v-model="number"></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <v-textarea placeholder="Paste your lines here" v-model="text"></v-textarea>
          </v-flex>
          <v-flex xs12 sm6>
            <v-textarea placeholder="Result" v-model="result"></v-textarea>
          </v-flex>
          <v-flex xs12>
            <v-btn color="primary" @click="pick()">Pick</v-btn>
          </v-flex>
          <actions :result="result" />
        </v-layout>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    text: '',
    result: '',
    number: 1
  }),
  methods: {
    pick() {
      let lines = this.text.split('\n')
      let num = this.number > lines.length ? lines.length : this.number
      let pickLines = []
      for (let i = 0; i < num; i++) {
        const random = Math.round(Math.random() * (lines.length - 1))
        pickLines.push(lines[random])
        lines.splice(random, 1)

      }
      this.result = pickLines.join('\n')
    }
  }
}
</script>

<style>
</style>